export enum TextAccessibilityAttribute {
  TEXT_ACCESSIBILITY_ATTRIBUTE_UNKNOWN = 'TEXT_ACCESSIBILITY_ATTRIBUTE_UNKNOWN',
  /**
   * Headings
   */
  TEXT_ACCESSIBILITY_ATTRIBUTE_H1 = 'TEXT_ACCESSIBILITY_ATTRIBUTE_H1',
  TEXT_ACCESSIBILITY_ATTRIBUTE_H2 = 'TEXT_ACCESSIBILITY_ATTRIBUTE_H2',
  TEXT_ACCESSIBILITY_ATTRIBUTE_H3 = 'TEXT_ACCESSIBILITY_ATTRIBUTE_H3',
  TEXT_ACCESSIBILITY_ATTRIBUTE_H4 = 'TEXT_ACCESSIBILITY_ATTRIBUTE_H4',
  TEXT_ACCESSIBILITY_ATTRIBUTE_H5 = 'TEXT_ACCESSIBILITY_ATTRIBUTE_H5',
  /**
   * Paragraph
   */
  TEXT_ACCESSIBILITY_ATTRIBUTE_P = 'TEXT_ACCESSIBILITY_ATTRIBUTE_P',
}
